<div style="position: relative" *ngIf="monument">
	<div class="text-center loaderDiv" *ngIf="flowLoading">
		<label>Ενημέρωση</label>
		<div class="preloader3 loader-block" style="height: 100%;">
			<div class="circ1"></div>
			<div class="circ2"></div>
			<div class="circ3"></div>
			<div class="circ4"></div>
		</div>
	</div>
	<form novalidate>
		<div class="text-right">
			<button type="button" class="btn btn-primary mr-2" (click)="createMonument()" *ngIf="!hiddenButtons.addMonument">
				Νέος Χώρος
			</button>
			<button type="button" class="btn btn-success mr-2" (click)="saveMonument()">Αποθήκευση</button>
			<button type="button" class="btn btn-danger" (click)="deleteSite()" *ngIf="!hiddenButtons.deleteMonument">Διαγραφή</button>
		</div>
	</form>
	<div class="row mt-3">
		<div class="col-md-6">
			<app-translation-tab titleName="Όνομα Μνημείου"
								 bindingAttribute="name"
								 [(translationArray)]="monument.monumentTranslations">
			</app-translation-tab>
		</div>
		<div class="col-md-6">
			<app-translation-tab titleName="Μικρή περιγραφή"
								 bindingAttribute="shortDescription"
								 [(translationArray)]="monument.monumentTranslations">
			</app-translation-tab>
		</div>
	</div>
</div>
